import { MessageInfo } from "../../../types/info";
import { OAAction } from "../../../types/actions";
import { GetOAReportResponse } from "../../../../../server/types/request/report/oa";

export type State = {
	loading: boolean;
	info: MessageInfo;
} & GetOAReportResponse;

export const initState: State = {
	job: undefined,
	data: [],
	columns: [],
	loading: true,
	info: {
		isSuccess: true,
		message: "",
	},
};

export const reducer = (state: State, action: OAAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
